import React from 'react';
import { FormattedMessage } from 'react-intl';

import hotelPropType from 'constants/propTypes/hotel';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { Row, Column } from 'components/shared/Layout';

const ExtrasHotel = ({ hotel }) => {
  const { passenger, checkInDate, jacTravelRef, hotelId, eurostarReference, currency, price, margin } = hotel;

  return (
    <div data-cy="extras-hotel">
      <Row>
        <Column span={3}>
          <strong>
            <FormattedMessage id="extras.passenger" />
          </strong>
          {passenger && (
            <div>
              {passenger.firstName} {passenger.lastName}
            </div>
          )}
        </Column>
        <Column span={3}>
          <strong>
            <FormattedMessage id="extras.hotel.checkInDate" />
          </strong>
          <div>{checkInDate}</div>
        </Column>
        <Column span={3}>
          <strong>
            <FormattedMessage id="extras.hotel.jacTravelReference" />
          </strong>
          <div>{jacTravelRef}</div>
        </Column>
        <Column span={2}>
          <strong>
            <FormattedMessage id="extras.hotel.id" />
          </strong>
          <div>{hotelId}</div>
        </Column>
        <Column span={2}>
          <strong>
            <FormattedMessage id="extras.hotel.eurostarPackageRef" />
          </strong>
          <div>{eurostarReference}</div>
        </Column>
        <Column span={1}>
          <strong>
            <FormattedMessage id="extras.hotel.margin" />
          </strong>
          <div>
            <FormattedCurrency currency={currency} amount={margin} />
          </div>
        </Column>
        <Column span={2}>
          <strong>
            <FormattedMessage id="extras.priceWithoutMargin" />
          </strong>
          <div>
            <FormattedCurrency currency={currency} amount={price} />
          </div>
        </Column>
      </Row>
      <hr />
    </div>
  );
};

ExtrasHotel.propTypes = {
  hotel: hotelPropType.isRequired
};

export default ExtrasHotel;
